import { initSiteHeader } from '../blocks/SiteHeader/SiteHeader';
import { initSiteFooter } from '../blocks/SiteFooter/SiteFooter';
import { initSplitBlocks } from '../blocks/Split/Split';
import { initFAQBlocks } from '../blocks/FAQ/FAQ';
import { initCityMaps } from '../blocks/CityMap/CityMap';
import { initLogin } from '../blocks/Login/Login';
import { initStoragesBlocks } from '../blocks/Storages/Storages';
import { initAnchorLinksBlock } from '../blocks/AnchorLinksBlock/AnchorLinksBlock';
import { initFilesBlock } from '../blocks/FilesBlock/FilesBlock';
import { initErrorReportBlocks } from '../blocks/ErrorReport/ErrorReport';
import { initCookieConsentBlock } from '../blocks/CookieConsent/CookieConsent';

import { initInfoLayout } from './layout/info-layout';
import { initAccordions } from './layout/accordion';

import objectFitImages from 'object-fit-images';

require('intersection-observer');

jQuery(() => {
    initSiteHeader();
    initSiteFooter();
    initCookieConsentBlock();
    initSplitBlocks();
    initFAQBlocks();
    initCityMaps();
    initInfoLayout();
    // initMomentumDisplay()
    // initLogin();
    initStoragesBlocks();
    initAccordions();
    initAnchorLinksBlock();
    initFilesBlock();
    initErrorReportBlocks();
    objectFitImages();
});

const loginBtns = [].slice.apply(document.getElementsByClassName('is--for--login'));

loginBtns.forEach(btn => {
    btn.addEventListener('click', event => {
        event.preventDefault();
        document.dispatchEvent(new Event('rb.login.toggle'));
    });
});
